import Swal from 'sweetalert2'
import {useNavigate, useParams} from 'react-router-dom'
import React, {useEffect, useState} from 'react'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import axios from 'axios'
import {useIntl} from 'react-intl'
import {Calendar} from 'primereact/calendar'
import {MultiSelect} from 'primereact/multiselect'
import moment from 'moment'
import makeAnimated from 'react-select/animated'
import CurrencyInput from 'react-currency-input-field'
import AsyncSelect from 'react-select/async'
import {colourStyles} from '../styles/styles'
import {Toolbar2} from '../../../../../../_metronic/layout/components/toolbar/Toolbar2'
import {PageTitle} from '../../../../../../_metronic/layout/core'

import {
  EvaluationReport,
  EvaluationReportInitValues as initialValues,
} from '../../components/evaluationReport-list/core/_models'
import {insertDataTime} from '../../../../../../util/insertDataTime'

const API_URL = process.env.REACT_APP_API_URL || 'api'
interface UseOption {
  readonly value: string
  readonly label: string
}

const ownerSchema = Yup.object().shape({
  // name: Yup.string().required('Campo obrigatório'),
  // issue_organs: Yup.number().required('Campo obrigatório'),
  // telephone: Yup.string().required('Campo obrigatório'),
  //descripton: Yup.string().required('Campo obrigatório'),
  // email: Yup.string().required('Campo obrigatório'),
})

const FormEvaluationReportAdd: React.FC = () => {
  const intl = useIntl()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const animatedComponents = makeAnimated()
  const [issue_dateD, setissue_dateD] = useState<Date | undefined>(undefined)
  const [year, setYear] = useState<Date | undefined>(undefined)
  const {id}: any = useParams()
  const [selectedCostCenters, setSelectedCostCenters] = useState(null)
  const [costCenters, setCostCenters] = useState([])
  const [propertyID, setPropertyID] = useState([])

  const resp = localStorage.getItem('auth_storage')
  let token = ''
  if (resp) {
    token = JSON.parse(resp)
  }
  let config = {
    headers: {
      Authorization: 'Bearer ' + token,
    },
  }

  const formik = useFormik<EvaluationReport>({
    initialValues,
    validationSchema: ownerSchema,
    onSubmit: async (values) => {
      setLoading(true)
      try {
        await axios.post(`${API_URL}/sgt/v1/evaluation_reports`, values, config)
        setLoading(false)
        Swal.fire({
          icon: 'success',
          title: intl.formatMessage({id: 'EVALUATION_REPORT.SWAL_ADD'}),
          showConfirmButton: false,
          timer: 2000,
        })
        navigate('/evaluationreports')
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: intl.formatMessage({id: 'EVALUATION_REPORT.SWAL_ADD_ERROR'}),
          showConfirmButton: false,
          timer: 1500,
        })

        setLoading(false)
      }
    },
  })
  function resetInputs() {
    formik.resetForm()
  }

  const InitialProperty = () => {
    getProperties()
    async function getProperties() {
      const {data} = await axios.get(API_URL + '/sgt/v1/properties/select2')
      let Response = data.results

      for (const element of Response) {
        const property: any = []
        if (element.id == id) {
          property.push({
            value: element.id,
            label: element.name,
          })
          formik.setFieldValue('property_id', property)
          setPropertyID(property)
          getEvaluationReportNumber(element.id)
        }
      }
    }
  }

  const loadOptionsPropertyID = (inputValue: string, callback: (options: UseOption[]) => void) => {
    setTimeout(() => {
      getProperties()

      let owners: any = []
      async function getProperties() {
        const {data} = await axios.get(API_URL + '/sgt/v1/properties/select2')
        let Response = data.results
        if (Response) {
          for (const element of Response) {
            const owner: any = {
              value: element.id,
              label: element.name,
            }
            owners.push(owner)
          }
        }
      }
      callback(owners)
    }, 1000)
  }

  const handleInputChangePropertyID = (event: any) => {
    let inputValue = ''
    inputValue = event.value
    formik.setFieldValue('property_id', inputValue.toString())
    setPropertyID(event)
    getEvaluationReportNumber(parseInt(inputValue))
    return {inputValue}
  }

  async function getEvaluationReportNumber(propertyID: number) {
    const {data} = await axios.get(
      `${API_URL}/sgt/v1/evaluation_reports/project_property?property_id=${propertyID}`
    )
    const date = new Date()
    let number = `${data.project_code} - ${date.getFullYear()} - ${
      data.evaluation_report_sequential
    }`
    console.log('number', number)
    formik.setFieldValue('evaluation_report_number', number)
  }

  const setConvertDate = (e: any, typeDate: 'year' | 'date') => {
    let DateFormate: any
    switch (typeDate) {
      case 'date': {
        DateFormate = moment(new Date(e)).format('YYYY-MM-DD')
        setissue_dateD(e)
        formik.setFieldValue('issue_date', DateFormate)
        break
      }
      case 'year': {
        DateFormate = moment(new Date(e)).format('YYYY')
        setYear(e)
        formik.setFieldValue('reference_year', DateFormate)
        break
      }
    }
  }

  const loadOptionsCostCenters = () => {
    setTimeout(() => {
      getCostcenters()
      let costCenters: any = []
      async function getCostcenters() {
        const {data} = await axios.get(API_URL + '/v1/cost_centers/select2')

        let Response = data.results

        if (Response) {
          for (const element of Response) {
            const costCenter: any = {
              code: element.id,
              name: element.name,
              // name: `${element.name} - ${element.descripton}`,
            }
            costCenters.push(costCenter)
          }
        }
      }
      setCostCenters(costCenters)
      return costCenters
    }, 1000)
  }

  insertDataTime()

  useEffect(() => {
    InitialProperty()
    loadOptionsCostCenters()
  }, [propertyID])

  return (
    <div className='card card-custom mt-n8'>
      {/* Component Header de Cadastros. */}
      <Toolbar2 icon={false} subtitle={intl.formatMessage({id: 'COMMON.BACK_BUTTON'})} />
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({id: 'EVALUATION_REPORT.ADD_TITLE'})}
      </PageTitle>

      <div id='kt_account_profile_details' className='collapse show'>
        <form onSubmit={formik.handleSubmit} noValidate className='form'>
          <div className='card-body border-top p-9'>
            <div className='col-lg-12 mb-1'>
              {/* INICIO LINHA 01*/}
              <div className='row mb-1'>
                <div className='col-lg-6'>
                  <label className={`col-form-label fw-bold fs-6`}>
                    {intl.formatMessage({id: 'EVALUATION_REPORT.NUMBER'})}
                  </label>

                  <input
                    type='text'
                    className='form-control form-control-lg form-control text-gray-400'
                    disabled
                    size={100}
                    {...formik.getFieldProps('evaluation_report_number')}
                  />
                </div>

                <div className='col-lg-6'>
                  <label className='col-lg-12 col-form-label required fw-bold fs-6'>
                    {intl.formatMessage({id: 'PROPERTIES.TITLE'})}
                  </label>
                  <AsyncSelect
                    className='form-control form-control-lg form-control-solid p-1 ps-3'
                    styles={colourStyles}
                    components={animatedComponents}
                    cacheOptions
                    value={propertyID}
                    loadOptions={loadOptionsPropertyID}
                    filterOption={(option, inputValue) =>
                      option.label
                        ? option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                        : false
                    }
                    defaultOptions
                    onChange={handleInputChangePropertyID}
                    placeholder={intl.formatMessage({
                      id: 'PROPERTIES.TITLE',
                    })}
                    theme={(theme) => ({
                      ...theme,
                      colors: {
                        ...theme.colors,
                      },
                    })}
                  />
                </div>
              </div>
            </div>

            <div className='col-lg-12 mb-1'>
              {/* INICIO LINHA 01*/}
              <div className='row mb-1'>
                <div className='col-lg-6'>
                  <label className='col-lg-12 col-form-label required fw-bold fs-6'>
                    {intl.formatMessage({id: 'COMMON.TYPE'})}
                  </label>
                  <select
                    className='form-select fs-6 form-select-solid form-select-lg fw-bold'
                    {...formik.getFieldProps('type')}
                  >
                    <option className='text-gray-400'>Selecione o Tipo</option>

                    <option value='annual_servitude'>
                      {intl.formatMessage({id: 'INDEMNITY_ITEM_AREA.ANNUAL_SERVITUDE'})}
                    </option>
                    <option value='single_servitude'>
                      {intl.formatMessage({id: 'INDEMNITY_ITEM_AREA.SINGLE_SERVITUDE'})}
                    </option>
                    <option value='direct_damage'>
                      {intl.formatMessage({id: 'INDEMNITY_ITEM_AREA.DIRECT_DAMAGE'})}
                    </option>
                    <option value='business_interruption'>
                      {intl.formatMessage({id: 'INDEMNITY_ITEM_AREA.BUSINESS_INTERRUPTION'})}
                    </option>
                  </select>
                  {formik.touched.type && formik.errors.type && (
                    <div className='fv-plugins-message-container text-danger'>
                      <div className='fv-help-block'>{formik.errors.type}</div>
                    </div>
                  )}
                </div>

                <div className='col-lg-6'>
                  <label className='col-lg-12 col-form-label required fw-bold fs-6'>
                    {intl.formatMessage({id: 'COMMON.STATUS'})}
                  </label>
                  <select
                    className='form-select fs-6 form-select-solid form-select-lg fw-bold'
                    {...formik.getFieldProps('status')}
                  >
                    <option className='text-gray-400'>Selecione o status</option>

                    <option value='opened'>
                      {intl.formatMessage({id: 'EVALUATION_REPORT.STATUS_OPENED'})}
                    </option>
                    <option value='concluded'>
                      {intl.formatMessage({id: 'EVALUATION_REPORT.STATUS_CONCLUDED'})}
                    </option>
                    <option value='canceled'>
                      {intl.formatMessage({id: 'EVALUATION_REPORT.STATUS_CANCELED'})}
                    </option>
                  </select>
                  {formik.touched.status && formik.errors.status && (
                    <div className='fv-plugins-message-container text-danger'>
                      <div className='fv-help-block'>{formik.errors.status}</div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className='col-lg-12 mb-1'>
              {/* INICIO LINHA 01*/}
              <div className='row mb-1'>
                <div className='col-lg-6'>
                  {/* <Input3
                    key='reference_year'
                    title={intl.formatMessage({id: 'COMMON.YEAR'})}
                    placeholder={intl.formatMessage({id: 'COMMON.YEAR'})}
                    {...formik.getFieldProps('reference_year')}
                    required
                  /> */}
                  <label className='col-lg-12 col-form-label required fw-bold fs-6'>
                    {intl.formatMessage({id: 'COMMON.YEAR'})}
                  </label>
                  <Calendar
                    inputClassName='form-control form-control-solid fs-5 ps-6 fw-bold border-white'
                    style={{
                      width: '100%',
                    }}
                    id='yearpicker'
                    view='year'
                    dateFormat='yy'
                    onChange={(e: any) => setConvertDate(e.value, 'year')}
                    value={year}
                  />
                </div>
                <div className='col-lg-6'>
                  <label className='col-lg-12 col-form-label required fw-bold fs-6'>
                    {intl.formatMessage({id: 'LICENSES.ISSUE_DATE'})}
                  </label>
                  <Calendar
                    value={issue_dateD}
                    onChange={(e: any) => setConvertDate(e.value, 'date')}
                    selectionMode='single'
                    inputClassName='form-control form-control-solid fs-5 ps-6 fw-bold border-white'
                    style={{
                      width: '100%',
                    }}
                    dateFormat='dd/mm/yy'
                    placeholder='dd/mm/aaaa'
                    showButtonBar
                  />
                </div>
              </div>
            </div>

            <div className='col-lg-12 mb-1'>
              {/* INICIO LINHA 01*/}
              <div className='row mb-1'>
                <div className='col-lg-6'>
                  <label className='col-lg-12 col-form-label  fw-bold fs-6'>
                    {intl.formatMessage({id: 'COST_CENTER.TITLE'})}
                  </label>
                  <MultiSelect
                    className='form-control form-control-lg form-control-solid p-1 pl-1 border border-white'
                    value={selectedCostCenters}
                    options={costCenters}
                    style={{
                      fontFamily: 'Poppins',
                      fontSize: '1.15rem',
                      fontWeight: 'medium',
                    }}
                    onChange={(e) => {
                      formik.setFieldValue(
                        'cost_center_id',
                        e.value.map((v: any) => {
                          return v.code
                        })
                      )

                      setSelectedCostCenters(e.value)
                    }}
                    placeholder={intl.formatMessage({
                      id: 'COST_CENTER.TITLE',
                    })}
                    optionLabel='name'
                    filter
                    display='chip'
                  />
                </div>
                <div className='col-lg-6'>
                  <label className='col-lg-12 col-form-label  fw-bold fs-6'>
                    {intl.formatMessage({id: 'EVALUATION_REPORT.DISCOUNT'})}
                  </label>
                  <CurrencyInput
                    name='discount'
                    className='form-control form-control-lg form-control-solid'
                    intlConfig={{locale: 'pt-BR', currency: 'BRL'}}
                    decimalScale={0}
                    allowDecimals={true}
                    onValueChange={(value) => formik.setFieldValue('discount', value || 0)}
                    placeholder={intl.formatMessage({id: 'EVALUATION_REPORT.DISCOUNT_PLACEHOLDER'})}
                  />
                </div>
              </div>
            </div>
            <div className='col-lg-12 mb-1'>
              <label className='col-lg-12 col-form-label  fw-bold fs-6'>
                {intl.formatMessage({id: 'CONDITIONINGS.OBSERVATION'})}
              </label>
              {/* INICIO LINHA 01*/}
              <textarea
                className='form-control form-control-lg form-control-solid'
                id='observations'
                cols={15}
                rows={5}
                {...formik.getFieldProps('observations')}
              ></textarea>
            </div>

            <div className='d-flex justify-content-end py-6'>
              <button type='submit' className='btn btn-sm btn-primary' disabled={loading}>
                {!loading && intl.formatMessage({id: 'COMMON.SAVE_BUTTON'})}
                {loading && (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    {intl.formatMessage({id: 'COMMON.SAVING_BUTTON'})}{' '}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
              <button type='reset' onClick={resetInputs} className='btn btn-sm btn-secondary  mx-2'>
                {intl.formatMessage({id: 'COMMON.CLEAR_BUTTON'})}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}

export {FormEvaluationReportAdd}
